import app from "app.controller"
import { action, observable } from "mobx"
import shop from "shop/shop"
import productStore from "stores/productStore"

let count = 0
export default class LineItem {
  @observable loading = false
  @observable ready = false
  key = `LineItem-${count++}`
  count = 1
  dirty = false
  product = false
  map_id = ""
  articleNumber = false

  constructor( articleNumber = "", count, callback ) {
    this.count = Number( count )
    this.articleNumber = articleNumber
    if ( this.articleNumber ) {
      this.fetchProduct( articleNumber )
        .then( () => {
          if ( callback ) callback()
        } )
    }
  }

  @action
  async fetchProduct( articleNr, artnr = 1, sort = "sort" ) {
    this.articleNumber = articleNr
    this.dirty = true
    this.loading = true
    this.ready = false
    let search = await shop.fetchCached( `/shop/rest/data/search/typeahead?value=${articleNr}&count=5&sort=${sort}&artnr=${artnr}${app.getQueryLanguageParameter()}` )
    this.product = false

    if ( search.length >= 1 ) {
      let product = await productStore.get( search[ 0 ].id )
      if ( product ) {
        this.ready = true
        this.product = product
        if ( this.count ) {
          this.product.count = this.count
        }
        let ok = this.product.validateCount(this.count)
      }
    }

    this.loading = false
    return this.product
  }
}



// WEBPACK FOOTER //
// ./src/sdk/LineItem.js